// Returns true when any node in a branch (or any of its descendants) actually
// executed at runtime. A branch only counts as "not taken" when every node in
// it has ran === false. This prevents a manually-skipped step at the top of a
// taken branch from being treated as "branch not taken" by the timeline UI.
const branchHasAnyExecution = (childSet = []) => {
  if (!Array.isArray(childSet)) {
    return false;
  }

  for (const node of childSet) {
    if (node?.ran !== false) {
      return true;
    }

    if (Array.isArray(node?.children)) {
      for (const grandChildSet of node.children) {
        if (branchHasAnyExecution(grandChildSet)) {
          return true;
        }
      }
    }
  }

  return false;
};

export default branchHasAnyExecution;
